export const SITE = {
  productName: "ZopDesk",
  tagline: "The helpdesk your store runs on.",
  url: "https://zopdesk.com",
  appUrl: "https://app.zopdesk.com",
  // The one place the public contact address lives. Change it here and every
  // page (contact, footer, legal pages) follows.
  contactEmail: "hello@zopdesk.com",
};
